import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllProductCategory: () => {
    return axios.get(API_URL.PRODUCT_CATEGORY, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  createProductCategory: (data) => {
    return axios.post(API_URL.PRODUCT_CATEGORY, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
};
